"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationsAPI = void 0;
const clear_1 = require("./clear");
const retrieve_1 = require("./retrieve");
const confirmReads_1 = require("./confirmReads");
const socket_io_client_1 = require("socket.io-client");
class NotificationsAPI {
    baseUrl;
    socketUrl;
    constructor(baseUrl, socketUrl) {
        this.baseUrl = baseUrl;
        this.socketUrl = socketUrl;
    }
    clear = clear_1.clear;
    retrieve = retrieve_1.retrieve;
    confirmReads = confirmReads_1.confirmReads;
    createAuthenticatedSocket(authToken) {
        const socket = (0, socket_io_client_1.io)(this.socketUrl, {
            path: "/notifications/socket.io",
            withCredentials: true,
            transports: ["websocket"],
            auth: {
                token: authToken
            }
        });
        return socket;
    }
}
exports.NotificationsAPI = NotificationsAPI;
//# sourceMappingURL=index.js.map